import React from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import {
  Alert,
  Button,
  IconButton,
  Snackbar,
  Stack,
} from '@mui/material';


const SalonThemeFeedbackToast = ({
  open,
  message,
  severity = 'info',
  actionLabel,
  closeLabel,
  direction = 'ltr',
  onAction,
  onClose,
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    onClose();
  };

  return (
    <Snackbar
      data-testid="salon-theme-feedback-toast"
      open={open}
      autoHideDuration={severity === 'error' ? 8000 : 5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      style={{
        '--salon-theme-feedback-bottom': 'calc(16px + var(--salon-theme-action-footer-height, 0px))',
        '--salon-theme-feedback-mobile-bottom': 'calc(100px + var(--salon-theme-action-footer-height, 0px))',
      }}
      sx={{
        bottom: {
          xs: 'var(--salon-theme-feedback-mobile-bottom) !important',
          sm: 'var(--salon-theme-feedback-bottom) !important',
        },
      }}
    >
      <Alert
        dir={direction}
        role={severity === 'error' ? 'alert' : 'status'}
        severity={severity}
        variant="filled"
        action={(
          <Stack direction="row" spacing={0.5} alignItems="center">
            {actionLabel ? (
              <Button
                color="inherit"
                size="small"
                onClick={onAction}
                sx={{ minHeight: 44 }}
              >
                {actionLabel}
              </Button>
            ) : null}
            <IconButton
              aria-label={closeLabel}
              color="inherit"
              size="small"
              onClick={handleClose}
              sx={{ minWidth: 44, minHeight: 44 }}
            >
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </Stack>
        )}
        sx={{ width: '100%', fontWeight: 600 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SalonThemeFeedbackToast;
